import axios from "axios";
import { GoogleKeys } from "../config/google";
import api from "./api";
import countryStateApiInstance from "./countryStateApi";



// 🏢 Get all states of India
export const getStates = async () => {
  try {
    const response = await countryStateApiInstance.get("/countries/IN/states");
    return response.data;
  } catch (error) {
    console.error("Error fetching states:", error.message);
    return [];
  }
};


// 🏙️ Get districts (cities) of a selected state
export const getDistricts = async (stateId) => {
  try {
    const response = await countryStateApiInstance.get(`/countries/IN/states/${stateId}/cities`);
    return response.data;
  } catch (error) {
    console.error("Error fetching districts:", error.message);
    return [];
  }
};



export const getCities = async (districtName) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json`,
        {
          params: {
            input: districtName, // District ka naam pass karo
            types: "(cities)",   // Sirf cities ka result chahiye
            key: GoogleKeys.GOOGLE_MAPS_API_KEY,
          },
        }
      );
      return response.data.predictions.map((city) => ({
        value: city.description,
        label: city.description,
      }));
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  };




export const fetchPlaceDetails = async (placeId) => {
  try {
    const response = await api.get("/api/location/details", {
      params: { placeId },
    });

    const { success, data, message } = response.data;

    if (!success || !data?.result) {
      throw new Error(message || "Failed to fetch location details");
    }

    const place = data.result;

    return {
      formatted_address: place.formatted_address,
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
    };
  } catch (error) {
    console.error("[Place Details Error]", error);
    throw new Error(error.response?.data?.message || "Error fetching place details");
  }
};
